var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.022,
    height: 18.022,
    viewBox: "0 0 18.022 18.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.25 -0.25)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.253,
    cy: 2.253,
    r: 2.253,
    transform: "translate(7.008 7.008)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.819,11.514a1.239,1.239,0,0,0,.248,1.367l.045.045a1.5,1.5,0,1,1-2.125,2.125l-.045-.045a1.249,1.249,0,0,0-2.118.886v.128a1.5,1.5,0,1,1-3,0v-.068a1.239,1.239,0,0,0-.811-1.134,1.239,1.239,0,0,0-1.367.248l-.045.045a1.5,1.5,0,1,1-2.125-2.125l.045-.045a1.249,1.249,0,0,0-.886-2.118H2.5a1.5,1.5,0,0,1,0-3H2.57A1.239,1.239,0,0,0,3.7,7.008a1.239,1.239,0,0,0-.248-1.367L3.411,5.6A1.5,1.5,0,1,1,5.536,3.471l.045.045a1.239,1.239,0,0,0,1.367.248h.06A1.239,1.239,0,0,0,7.759,2.63V2.5a1.5,1.5,0,1,1,3,0V2.57a1.249,1.249,0,0,0,2.118.886l.045-.045a1.5,1.5,0,1,1,2.125,2.125l-.045.045a1.239,1.239,0,0,0-.248,1.367v.06a1.239,1.239,0,0,0,1.134.751h.128a1.5,1.5,0,1,1,0,3h-.068A1.239,1.239,0,0,0,14.819,11.514Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.fd924ffd420f76b6a30c0af113a154bf.svg";
export { ForwardRef as ReactComponent };